import { CommonBrickSettingRemoteDto } from '../../../../../../generated/signalR/common-brick-setting-remote-dto';
import { Selector } from '@ngxs/store';
import { SettingsState } from '../../../../settings/settings.state';
import { CommonBrickSettingsState, CommonBrickSettingsStateModel } from './common-brick-settings.state';
import { getBrickSettingModel } from './getBrickSettingModelFunction';

export class CommonBrickSettingsSelectors {
   @Selector([CommonBrickSettingsState])
   public static getBrickSettingModelFn(state: CommonBrickSettingsStateModel): (brickId: string) => CommonBrickSettingRemoteDto {
      return (brickId: string, ignoreEditModeValues: boolean = false) => {
         return getBrickSettingModel(state, brickId, true, ignoreEditModeValues);
      };
   }

   @Selector([CommonBrickSettingsSelectors.getBrickSettingModelFn])
   public static getOverwrittenBrickTitleFn(getBrickSettingModelFn: (brickId: string) => CommonBrickSettingRemoteDto) {
      return (brickId: string) => {
         return getBrickSettingModelFn(brickId).brickOverwrittenTitle;
      };
   }

   @Selector([CommonBrickSettingsSelectors.getBrickSettingModelFn])
   public static getBrickScalingFn(getBrickSettingModelFn: (brickId: string) => CommonBrickSettingRemoteDto) {
      return (brickId: string) => {
         return getBrickSettingModelFn(brickId).brickScaling;
      };
   }

   @Selector([CommonBrickSettingsSelectors.getBrickScalingFn, SettingsState.getGlobalBrickScaling])
   public static getEffectiveBrickScalingFn(getBrickScalingFn: (brickId: string) => number, globalBrickScaling: number) {
      return (brickId: string) => {
         const brickSpecificScaling = getBrickScalingFn(brickId);
         return (globalBrickScaling * brickSpecificScaling) / 100;
      };
   }
}
